var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, action } from 'mobx';
import { withDefault } from '../../../utils/serializr/schema/middle/withDefault';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { object } from '../../../utils/serializr/schema/object';
import { SortableItem } from '../SortableItem/SortableItem';
import { list } from '../../../utils/serializr/schema/list';
import { SortableList } from '../SortableList/SortableList';
import { SortableStoreStateOverall } from './SortableStoreStateOverall';
import { editable } from '../../../utils/mobx/decorators/editable';
import { primitive } from '../../../utils/serializr/serializr';
export class SortableStore {
    parent;
    sortableLists;
    sortableItems;
    successStates;
    startState;
    maxMoves;
    constructor({ parent }) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    applyState(overall) {
        overall.sortableItemStates.forEach((s) => {
            const item = this.getItemById(s.sortableItemId);
            if (item) {
                item.droppableId = s.droppableId;
                item.indexInDroppable = s.indexInDroppable;
            }
        });
    }
    getItemById(id) {
        return this.sortableItems.find(item => item.id === id);
    }
    static get serializeInfo() {
        return {
            props: {
                sortableLists: withDefault(list(object(SortableList, { parentDepth: 2 })), [{}]),
                sortableItems: withDefault(list(object(SortableItem, { parentDepth: 2 })), []),
                successStates: withDefault(list(object(SortableStoreStateOverall, { parentDepth: 2 })), []),
                startState: withDefault(object(SortableStoreStateOverall, { parentDepth: 2 }), {}),
                maxMoves: withDefault(primitive, 5),
            },
            afterDeserialize: async ({ target, context }) => {
                target.applyState(target.startState);
            },
        };
    }
}
__decorate([
    editable('shallow')
], SortableStore.prototype, "sortableLists", void 0);
__decorate([
    editable('shallow')
], SortableStore.prototype, "sortableItems", void 0);
__decorate([
    editable('shallow')
], SortableStore.prototype, "successStates", void 0);
__decorate([
    editable()
], SortableStore.prototype, "startState", void 0);
__decorate([
    editable()
], SortableStore.prototype, "maxMoves", void 0);
__decorate([
    action.bound
], SortableStore.prototype, "applyState", null);
__decorate([
    memoize
], SortableStore, "serializeInfo", null);
